var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [_c("sidebar")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "column is-9" }, [_c("router-view")], 1),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }